import React from "react";
import {
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
} from "react-icons/fa";
import { BsTwitterX } from "react-icons/bs";

const Footer = () => {
  const footerSections = [
    {
      title: "Company Info",
      className: "col-lg-2 col-md-6 col-6",
      links: [
        { label: "About us", href: "https://abym.in/about-us" },
        { label: "Introduction", href: "https://abym.in/about-us" },
        { label: "Terms & Conditions", href: "/terms-condition" },
        { label: "Privacy Policy", href: "https://abym.in/privacy-policy" },
      ],
      badge: "https://media.abym.in/Abym-Web/icon/iso-award.webp",
    },
    {
      title: "Services",
      className: "col-lg-2 col-md-6 col-6",
      links: [{ label: "Industries", href: "https://abym.in/industries" }],
    },
    {
      title: "Industries",
      className: "col-lg-3 col-md-6 col-6",
      links: [
        { label: "Healthcare", href: "https://abym.in/industries#healthcare" },
        { label: "eCommerce", href: "https://abym.in/industries#ecommerce" },
        { label: "Education", href: "https://abym.in/industries#education" },
        { label: "Wellness", href: "https://abym.in/industries" },
        { label: "Tour & Travel", href: "https://abym.in/industries" },
        { label: "Skill Development", href: "https://abym.in/industries" },
        { label: "Entertainment / Media", href: "https://abym.in/industries" },
        { label: "Games", href: "https://abym.in/industries#games" },
      ],
    },
    {
      title: "Portfolio",
      className: "col-lg-2 col-md-6 col-6",
      links: [
        { label: "Lal Path labs", href: "https://abym.in/portfolio" },
        { label: "Oncquest Labs", href: "https://abym.in/portfolio" },
        { label: "Admissify", href: "https://abym.in/portfolio" },
        { label: "Divine Beauty", href: "https://abym.in/portfolio" },
        { label: "Hero MotoCorp", href: "https://abym.in/portfolio" },
      ],
    },
    {
      title: "Others",
      className: "col-lg-3 col-md-6",
      links: [
        { label: "Career", href: "https://abym.in/career" },
        { label: "Blogs", href: "https://abym.in/blog" },
        { label: "Contact Us", href: "https://abym.in/contact-us" },
      ],
      badge: "https://media.abym.in/Abym-Web/icon/cmmi-award.webp",
      showSocial: true,
    },
  ];

  return (
    <footer>
      {/* TOP CTA SECTION */}
      <section className="top-footer">
        <div className="container">
          <div className="row align-items-center justify-content-between">
            <div className="col-lg-7 col-md-8">
              <h3>GET A FREE CONSULTATION FROM EXPERTS</h3>

              <p>
                Professional service for your software solutions
              </p>
            </div>

            <div className="col-lg-3 col-md-4 text-md-end text-start mt-4 mt-md-0">
              <a href="https://abym.in/contact-us">
                <button className="connect-btn">
                  Lets connect
                </button>
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* MAIN FOOTER */}
      <section className="main-footer">
        <div className="container">
          <div className="row gy-5">
            {footerSections.map((section) => (
              <div key={section.title} className={section.className}>
                <h4>{section.title}</h4>

                <ul>
                  {section.links.map((link) => (
                    <li key={link.label}>
                      <a href={link.href}>{link.label}</a>
                    </li>
                  ))}
                </ul>

                {section.showSocial && (
                  <div className="social-icons">
                    <a href="https://www.facebook.com/abymtechnology">
                      <FaFacebookF />
                    </a>

                    <a href="https://x.com/abymtechnology">
                      <BsTwitterX />
                    </a>

                    <a href="https://www.instagram.com/abymtechnology">
                      <FaInstagram />
                    </a>

                    <a href="https://www.linkedin.com/company/abym-technology">
                      <FaLinkedinIn />
                    </a>
                  </div>
                )}

                {section.badge && (
                  <img src={section.badge} alt="" className="badge-img" />
                )}
              </div>
            ))}
          </div>

          {/* COPYRIGHT */}
          <div className="copyright">
            <p>
              Copyright © 2026 AbyM Technology Private Limited.
              All rights reserved.
            </p>
          </div>
        </div>


      </section>
    </footer>
  );
};

export default Footer;
